<div class="filter-nav overflow-visible border-bottom bg-light py-2">
  <div class="container visible-xs-filter-bar w-100">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center ">
        <div class="strong  text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
        <div class="ml-2">
          <ng-select [items]="materialList" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
          groupBy="code" [selectableGroup]="true" placeholder="{{'home.productHeader.SelectProducts' | cxTranslate }}" [(ngModel)]="selectedProduct"
          [closeOnSelect]="true" bindValue="code" notFoundText="{{'home.productHeader.NoItemsFound' | cxTranslate }}"
          (change)="filterData()">
          <ng-template ng-multi-label-tmp>
            <span class="filter-count pl-2 text-black">{{selectedProduct?.length}}x selected</span>
          </ng-template>
          <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" class="dropdown-ng-template">           
            <!-- <input type="checkbox" /> -->
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <div>
              <input id="{{item.code}}" [ngModel]="item$.selected" [checked]="item.checked" type="checkbox" />
              <span>{{item.name}}</span>
            </div>
          </ng-template>
        </ng-select>
        </div>
        <div class="ml-3">
          <ng-select [items]="commodityType" [multiple]="true" [clearable]="false" bindLabel="description" dropdownPosition="bottom"
            groupBy="id" [selectableGroup]="true" placeholder="{{'heading.SelectCommodity' | cxTranslate }}" [(ngModel)]="commodity"
            [closeOnSelect]="true" bindValue="id" notFoundText="{{'heading.NoItemsFound' | cxTranslate }}"
            (change)="filterData()">
            <ng-template ng-multi-label-tmp>
              <span class="filter-count pl-2 text-black">{{commodity?.length}}x selected</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" class="dropdown-ng-template">           
              <!-- <input type="checkbox" /> -->
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div>
                <input id="{{item.id}}" [ngModel]="item$.selected" [checked]="item.checked" type="checkbox" />
                <span>{{item.description}}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div class="mr-3 picker">


          <input name="datepicker" placeholder="{{ 'home.contracts.dateRange' | cxTranslate }}"
            class="form-control mobile ml-2 mt-3 filter-bar-input" ngbDatepicker #datepicker="ngbDatepicker"
            [autoClose]="'outside'" (dateSelect)="onDateSelection($event,datepicker)"
            [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''"
            [displayMonths]="2" [dayTemplate]="t" [footerTemplate]="footerTemplate" autocomplete="off"
            outsideDays="hidden" [startDate]="startDate!" (click)="toggle(datepicker)">
          <ng-template #t let-date let-focused="focused">
            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
              {{ date.day }}
            </span>
          </ng-template>
          <ng-template #footerTemplate>
            <hr class="my-0">
            <button class="btn btn-primary btn-sm m-2 float-left" (click)="resetCalendar(datepicker)">{{
              'home.contracts.Reset' | cxTranslate }}</button>
            <button class="btn btn-secondary btn-sm m-2 float-right" (click)="datepicker.close()">{{ 'home.quote.Close'
              | cxTranslate }}</button>
          </ng-template>
        </div>
        <div class="mr-2">
          <ng-select (change)="filterData()" [clearable]="false"
            placeholder="{{ 'shipment.statusFilter' | cxTranslate }}" [dropdownPosition]="'bottom'"
            class="quote-status-selection filter-mobile " [(ngModel)]="selectedStatus" bindValue="id">
            <ng-option *ngFor="let item of statusTypes" [value]="item.code">{{ item.name.split("_").join(" ") }}
            </ng-option>
          </ng-select>
        </div>
       


        <div *ngIf="showClear">
          <button type="button" class="btn btn-link mb-0 btn-warning text-white" (click)="clearFilterData()"
            [style.visibility]="selectedStatus != null || startDate != null || commodity != null || selectedProduct!= null || clearBtn ? 'visible' : 'hidden'">{{
            'home.productHeader.ClearFilter' | cxTranslate }}</button>
        </div>
      </div>
      <div class="d-flex align-items-center mr-2 search-section-col">
        <div class="search-section-div">
          <div class="input-group d-flex align-items-center">
            <input class="form-control form-control-lg border rounded-pill input-field" type="search"
              (keypress)="omit_special_char($event)" [(ngModel)]="searchText" (input)="search()"
              placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
            <span class="input-group-append">
              <button name='searchbuttondesktop'
                class="btn btn-outline-secondary btnUpgrade rounded-pill border-0 input-field bg-white border-start-0 border-bottom-0 border ms-n5"
                type="button">
                <i class="fa fa-search pe-none"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="container hidden-xs-filter-bar">
    <div class="row">
      <div class="w-100">
        <div class="filter-select-div-mobile pl-4">
          <div class="input-group p-2">
            <input class="form-control form-control-lg border rounded-pill input-field" type="search"
              (keypress)="omit_special_char($event)" [(ngModel)]="searchText" (input)="search()"
              placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
            <span class="input-group-append">
              <button name='searchbuttonfilter' class="
                      btn
                      rounded-pill
                      border-0
                      input-field
                      border-start-0 border-bottom-0 border
                      ms-n5
                    " type="button">
                <i class="fa fa-search mobbar"></i>
              </button>
              <div class='hidden-xs-filter-bar vertical ml-4'></div>
              <div class='hidden-xs-filter-bar pr-2 pl-4' (click)='filtersidebar()'>
                <img class="ml-1" src="./images/filternew.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                  *ngIf='length'>{{length}}</sup>
                <div class="ff-semibold fs-10 d-flex align-items-center text-black Filternew">{{ 'home.filter.filters' |
                  cxTranslate }}</div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="background">
      <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' "
        class="hidden-xs-filter-bar sidebar">
        <div class='  d-flex justify-content-between p-3 border sticky'>
          <div class="fs-24 strong pl-1">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
          <div class="my-auto" (click)="closebar()"><img src="/images/sidebarcross.svg" alt="">
          </div>
        </div>
        <div>
          <div class="d-flex strong  pl-3 pt-3 pb-2">{{ 'home.contracts.date' | cxTranslate }}:</div>
          <form role="form" class="date-range-picker-form ml-4">
            <div class="form-group pr-3 mb-1">
              <div class="input-group">
                <div class="input-group-prepend">

                  <input name="datepicker" class="form-control form-control-lg filter-mob"
                    placeholder="{{'home.contracts.selectdaterange' | cxTranslate }}" ngbDatepicker
                    #datepicker1="ngbDatepicker" [autoClose]="'outside'"
                    (dateSelect)="onDateSelection($event,datepicker1)"
                    [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''"
                    [displayMonths]="2" [dayTemplate]="t" [footerTemplate]="footer" autocomplete="off"
                    outsideDays="collapsed" [startDate]="startDate!" (click)="toggle(datepicker1)"
                    placeholder="{{ 'home.contracts.dateRange' | cxTranslate }}">
                  <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                      {{ date.day }}
                    </span>
                  </ng-template>
                  <ng-template #footer>
                    <button class="btn btn-primary btn-sm m-2 float-left" (click)="resetCalendar(datepicker1)">{{
                      'home.contracts.Reset' | cxTranslate }}</button>
                    <button class="btn btn-secondary btn-sm m-2 float-right" (click)="datepicker1.close()">{{
                      'home.quote.Close' | cxTranslate }}</button>
                  </ng-template>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div>
          <div class="d-flex strong pl-3 pt-3 pb-2">{{ 'shipment.Status' | cxTranslate }}
          </div>
          <div *ngFor="let statusData of statusTypes; let i=index" class=" ml-5  d-flex line-height ">
            <label *ngIf="statusData.name!==undefined && statusData.name!==''">
              <input type="checkbox" [(ngModel)]="statusData.selected" [value]="statusData.code"
                [checked]="statusData.selected" (change)="onCheckboxstatusChange($event,statusData.code)" />
              {{statusData.code.split("_").join(" ") |titlecase}}
            </label>
          </div>
        </div>
        
        <div class="d-flex strong  pl-3 pt-3 pb-2">Material:</div>
        <div *ngFor="let materialData of materialList; let i=index" class="ml-5  d-flex line-height">
          <label class="ff-normal" >
            <input type="checkbox" [(ngModel)]="materialData.selected" [value]="materialData.code"
              [checked]="materialData.selected" (change)=" onCheckboxproductChange($event,materialData.code)" />
            {{materialData.name |titlecase}}
          </label>
        </div>
        <div class="d-flex strong  pl-3 pt-3 pb-2">Commodity Type:</div>
        <div *ngFor="let productData of commodityType; let i=index" class="ml-5  d-flex line-height">
          <label class="ff-normal" >
            <input type="checkbox" [(ngModel)]="productData.selected" [value]="productData.id"
              [checked]="productData.selected" (change)="onCheckboxcommodityChange($event , productData.id)" />
            {{productData.description |titlecase}}
          </label>
        </div>
          <!-- <div>
            <div class="d-flex strong  pl-4 pt-3 pb-2">{{ 'heading.commodityType' | cxTranslate }}:</div>
            <ng-select class="ml-4 commodity" [items]="commodityType" [multiple]="true" [clearable]="false" bindLabel="description" dropdownPosition="bottom"
            groupBy="id" [selectableGroup]="true" placeholder="{{'heading.SelectCommodity' | cxTranslate }}" [(ngModel)]="commodity"
            [closeOnSelect]="true" bindValue="id" notFoundText="{{'heading.NoItemsFound' | cxTranslate }}"
            >
            <ng-template ng-multi-label-tmp>
              <span class="filter-count pl-2 text-black">{{commodity.length}}x selected</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" class="dropdown-ng-template">           
              
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div>
                <input id="{{item.id}}" [ngModel]="item$.selected" [checked]="item.checked" type="checkbox" />
                <span>{{item.description}}</span>
              </div>
            </ng-template>
          </ng-select>
          
          </div> -->

        <div class="sticky-bottom p-4 border-top">
          <button class="btn btn-block btn-primary w-100" (click)="getShipmentResults()">{{ 'home.contracts.seeResults'
            |
            cxTranslate}}</button>
          <button class='btn btn-block ' (click)="clearFilterMobile($event)">{{ 'home.contracts.clearFilter' |
            cxTranslate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>